import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {ProductsArticleService} from './products-article.service';
import {StocksService} from './stocks.service';
import {ProductsArticle} from './products-article';
import {AppComponent} from './app.component';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {ActivatedRoute, Params} from '@angular/router';
import {SuppliersService} from './suppliers.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {Router} from '@angular/router';
import {LeftMenuComponent} from './left-menu.component';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'issue-stock_2',
    styleUrls: ['./styles/purchasing-list.component.css'],
    templateUrl: './templates/purchasing-list.component.html',
    providers: [ProductsArticleService, StocksService, AuthentificationService, TransactionsService, SuppliersService, SortTable, LeftMenuComponent, DatePipe]
})

export class PurchasingList implements OnInit {

    position: string = 'before';
    session_mode: string = "RECEPTION";
    refused_list: Array<any>;
    pannier_list: any;
    invalid_list: Array<any>;
    transaction_name: string = "";
    transaction_date_creation: string = "";
    transaction_reference: string = "";
    remark: string = "";
    id_transaction_detail: number = 0;
    validate_bt: boolean = true;
    validate_option: boolean = true;
    disable_edit_form: boolean = false;
    not_validate_details: boolean = true;
    supplier_list: Array<any>;
    selected_supplier_list: Array<any> = [];
    validate_disable: boolean = false;
    sortedDataRefused: any = [];
    sortedDataNotValidate: any = [];
    refuse_purcahse_order: any;
    show_dialog_confirm: boolean = false;
    validation_mode: string = "VALIDATION";
    succes_validation: boolean = false;
    selectedValue: string = "VALIDE";
    selected_purchase: any;
    action_value: string = 'accepter';
    temporary_transaction_name = "";
    last_remark = "";

    actions = [
        {value: 'VALIDE', viewValue: 'Accepter'},
        {value: 'REFUSE', viewValue: 'Refuser'},
        {value: 'DELETE', viewValue: 'Supprimer'}
    ];

    date_modif: Array<Date> = [];
    date_min: Date = new Date();

    constructor(private datepipe: DatePipe, private products_article_service: ProductsArticleService, private supplier_service: SuppliersService, private stocks_service: StocksService, private app_component: AppComponent, private lots_service: StocksService, private router: Router, private activated_route: ActivatedRoute, private authentification_service: AuthentificationService, private transactions_service: TransactionsService, private sort_table: SortTable, private left_menu: LeftMenuComponent) {
        this.CheckUSerSession();
        this.app_component.valTest = '/purchasing-list';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification']);
                }
            });
    }

    getRefusedPurchaseList(): void {
        this.transactions_service.getRefusedPurchaseList()
            .then(result => {
                this.refused_list = result['list'];
                this.sortedDataRefused = result['list'];
            });
    }

    GetNotValidatePurchaseList(): void {
        this.transactions_service.GetNotValidatePurchaseList().then(result => {this.sortedDataNotValidate = result['list']; this.GetTransactionDetails_cb(result['list']);/*this.invalid_list = result['list']*/});
    }

    Search(): void {

    }

    changeDateForThisSupplier(idx: any, time_limit: any): void {
        var someDate = this.addDays(Number(time_limit));
        var day = someDate.getDate();
        var month = someDate.getMonth();
        var year = someDate.getFullYear();
        this.date_modif[idx] = new Date(year, month, day);
    }

    addDays(numberOfDays: any) {
        var startDate = this.transaction_date_creation.split("-");;
        var returnDate = new Date(
            Number(startDate[2]),
            Number(startDate[1]) - 1,
            Number(startDate[0]) + numberOfDays,
            0,
            0,
            0);
        return returnDate;
    }

    AddtoCart(purchase: any, id_pram: any): void {

        //console.log(purchase);
        this.succes_validation = false;
        this.selected_purchase = purchase;

        this.validate_option = true;
        this.disable_edit_form = false;
        this.not_validate_details = true;
        this.id_transaction_detail = purchase.id_transaction_details;
        this.transactions_service.GetPurchaseDetails(purchase.id_transaction_details)
            .then(result => {
                this.SetSupplierArticle(result);
                this.pannier_list = result['list'];
                this.temporary_transaction_name = result['name'];
                this.transaction_name = result['name'];
                this.transaction_date_creation = result['date_creation'];
                this.transaction_reference = result['reference'];
                this.last_remark = result['remark'];
                this.remark = result['remark'];
                if (result['list'].length !== 0) {
                    this.validate_bt = false
                }
                for (let i = 0; i < this.sortedDataNotValidate.length; i++) {
                    //console.log(this.sortedDataNotValidate[i]);
                    if (this.sortedDataNotValidate[i]['id_transaction_details'] === id_pram) {
                        this.selected_tr = i;
                        break;
                    }
                }
                this.ValidationMode();
                this.initDates(this.pannier_list);
            });

    }

    Refuse(): void {
        this.transactions_service.RefusePurchasing(this.selected_purchase.id_transaction_details).then(result => {
            this.refused_list = result['refused'];
            this.sortedDataNotValidate = result['invalide'];
            this.sortedDataRefused = result['refused'];
            this.show_dialog_confirm = false;
            this.app_component.hide_wrapper(false);
            this.pannier_list = [];
        });
    }

    Delete(): void {
        this.transactions_service.DeletePurchasing(this.selected_purchase.id_transaction_details).then(result => {
            this.sortedDataNotValidate = result['invalide'];
            this.show_dialog_confirm = false;
            this.app_component.hide_wrapper(false);
            this.pannier_list = [];
        });
    }

    DialogConfirm(purchase: any): void {
        if (this.validation_mode === "MODIFICATION") {
            this.action_value = "modifier";
        } else {
            if (this.selectedValue === "VALIDE") {
                this.action_value = "accepter";
            } else if (this.selectedValue === "REFUSE") {
                this.action_value = "refuser";
            } else {
                this.action_value = "supprimer";
            }
        }
        this.selected_purchase = purchase;
        this.show_dialog_confirm = true;
        this.app_component.hide_wrapper(true);
    }

    DialogCancel(): void {
        this.show_dialog_confirm = false;
        this.app_component.hide_wrapper(false);
    }


    SortValidate(sort: Sort): void {
        console.log(this.refused_list);
        this.sort_table.SetDataArray(this.refused_list, [{value: "name", type: ""}, {value: "validator", type: ""}, {value: "date", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataRefused = this.sort_table.GetSortData();
    }

    SortNotValidate(sort: Sort): void {
        this.sort_table.SetDataArray(this.invalid_list, [{value: "name", type: ""}, {value: "applicant", type: ""}, {value: "date", type: ""}]);
        this.sort_table.sortData(sort);
        this.sortedDataNotValidate = this.sort_table.GetSortData();
    }

    AddtoCartValidate(purchase_id_transaction_d: any): void {
        this.succes_validation = false;
        this.validate_bt = true;
        this.not_validate_details = false;
        this.id_transaction_detail = purchase_id_transaction_d;
        this.transactions_service.GetPurchaseDetails(purchase_id_transaction_d)
            .then(result => {
                this.SetSupplierArticle(result);
                this.pannier_list = result['list'];
                this.transaction_name = result['name'];
                this.remark = result['remark'];
                this.initDates(this.pannier_list);
            });
    }


    RemoveFromPannierPurchaseDetail(pannier: any): void {
        if (!this.disable_edit_form) {
            this.transactions_service.RemoveFromPannierPurchaseDetail(pannier.id_article).then(pannier_list => {this.pannier_list = pannier_list['list']; if (pannier_list['result'] === "EMPTY") {this.validate_bt = true}; this.SetSupplierArticle(pannier_list); this.ValidationMode()});
        }
    }

    EditArticleSessionPurchaseDetail(pannier: any): void {
        this.transactions_service.EditArticleSessionPurchaseDetail(pannier.id_article).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list']); this.SetSupplierArticle(result);});
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
                this.validate_disable = true;
            }
        }
    }

    LoadSessionPurchase() {
        this.transactions_service.LoadSessionPurchaseDetail().then(session_list => {this.pannier_list = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false}; this.SetSupplierArticle(session_list);});
    }

    EditAndValidateModification(prod: any, idx: number): void {
        if (!this.disable_edit_form) {
            if (prod.status === "RECEPTION") {
                this.EditArticleSessionPurchaseDetail(prod);
            } else if (prod.status === 'MODIFICATION') {
                this.ValidateEditArticleSessionPurchaseDetail(prod, idx);
            }
        }
    }

    SetSupplierArticle(session: any): void {
        this.selected_supplier_list = [];
        for (let i = 0; i < session['list'].length; i++) {
            var current_supplier = session['list'][i]['current_supplier'];
            this.supplier_list[i] = session['list'][i]['supplier'];
            for (let m = 0; m < this.supplier_list[i].length; m++) {
                if (current_supplier == this.supplier_list[i][m].id_supplier) {
                    this.selected_supplier_list[i] = this.supplier_list[i][m].id_supplier;
                }
            }
        }
    }

    ValidateEditArticleSessionPurchaseDetail(prod: any, idx: number): void {
        if (isNaN(prod.quantity)) {
            prod.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionPurchase()}, 2000);
        }
        else {
            var date_line = (this.datepipe.transform(this.date_modif[idx], 'dd-MM-yyyy'));
            this.transactions_service.ValidateEditArticleSessionPurchaseDetail(prod, date_line, this.selected_supplier_list[idx])
                .then(result => {
                    this.pannier_list = result['list'];
                    this.SessionMod(result['list']);
                    this.ValidationMode();
                    this.initDates(this.pannier_list);
                });
        }
    }

    RegisterPannierPurchaseDetail(): void {
        this.transactions_service.RegisterPannierPurchaseDetail(this.transaction_name, this.remark, this.id_transaction_detail).then(result => {this.validate_option = false; this.transaction_name = ""; this.pannier_list = result['list']; this.remark = ""; this.refused_list = result['refused']; this.invalid_list = result['invalide']; this.validate_bt = true; this.disable_edit_form = true; this.InfosMessage()});
    }

    ValidatePannierPurchaseDetail(): void {
        this.transactions_service.ValidatePannierPurchaseDetails(this.id_transaction_detail).then(result => {
            this.pannier_list = result['result'];
            //this.transaction_name = "";
            this.remark = "";
            this.validate_option = true;
            this.refused_list = result['refused'];
            this.invalid_list = result['invalide'];
            this.validate_bt = true;
            this.disable_edit_form = true;
            this.transaction_name = "";
            this.transaction_date_creation = "";
            this.transaction_reference = "";
            this.sortedDataRefused = result['refused']; this.sort_table.SetDataArray(result['refused'], [{value: "name", type: ""}, {value: "validator", type: ""}, {value: "date", type: ""}]);
            this.sortedDataNotValidate = result['invalide']; this.sort_table.SetDataArray(result['invalide'], [{value: "name", type: ""}, {value: "applicant", type: ""}, {value: "date", type: ""}]);
            this.InfosMessage();


        });
    }

    GetTransactionDetails_cb(purchase_list: any): void {
        this.invalid_list = purchase_list;
        this.activated_route.params.subscribe((params: Params) => {

            let id = params['id_transaction_details'];
            if (id !== undefined) {
                let index = this.sortedDataNotValidate.findIndex(notvalidate => notvalidate.id_transaction_details === id);

                this.app_component.valTest = '/purchasing-list';
                this.app_component.GetParent();
                this.AddtoCart(this.sortedDataNotValidate[index], id);
            }
        });
    }

    CancelPannierPurchaseDetail(): void {
        this.transactions_service.CancelPannierPurchaseDetail().then(result => {this.pannier_list = result['list']; this.validate_bt = false; this.session_mode = "RECEPTION"; this.LoadSessionPurchase();});
    }

    GetSupplierList(): void {
        this.supplier_service.GetSupplierList().then(result => {this.supplier_list = result['list'];});
    }


    CleanPannierPurchaseDetail(): void {
        this.transactions_service.CleanPannierPurchaseDetail()
            .then(result => {
                this.transaction_name = "";
                this.transaction_date_creation = "";
                this.transaction_reference = "";
                this.remark = "";
                this.pannier_list = result['list'];
                this.validate_bt = false;
                this.session_mode = "RECEPTION";
                this.LoadSessionPurchase();
                this.validate_bt = true;
            });
    }

    ValidationMode(): void {
        //let indexofModif = this.pannier_list.findIndex(pannier => pannier.remark !== "");
        let indexofModif = this.pannier_list.findIndex(pannier => pannier.quantity_order !== pannier.quantity);
        let indexofModifDelete = this.pannier_list.findIndex(pannier => pannier.remark === "DELETE");
        let indexofModifsupplier = this.pannier_list.findIndex(pannier => pannier.current_supplier !== pannier.id_supplier);
        let indexofModifDeliveryDate = this.pannier_list.findIndex(pannier => pannier.current_delivery_date !== pannier.delivery_date);
        //
        //        console.log(indexofModif);
        //        console.log(indexofModifsupplier);
        //        console.log(indexofModifDeliveryDate);
        //        console.log(indexofModifDelete);

        if (indexofModif !== -1 || indexofModifsupplier !== -1 || indexofModifDeliveryDate !== -1 || indexofModifDelete !== -1) {
            this.validation_mode = "MODIFICATION";
        } else if ((indexofModif === -1) && (indexofModifsupplier === -1) && (indexofModifDeliveryDate === -1) && (indexofModifDelete === -1)) {
            this.remark = this.last_remark;
            this.validation_mode = "VALIDATION";
        }
    }

    ValidateButton(): void {
        this.DialogConfirm(this.selected_purchase);
    }

    ValidateAction(): void {
        if (this.validation_mode === "MODIFICATION") {
            this.RegisterPannierPurchaseDetail();
        } else {
            if (this.selectedValue === "VALIDE") {
                this.ValidatePannierPurchaseDetail();
            } else if (this.selectedValue === "REFUSE") {
                this.Refuse();
            } else {
                this.Delete();
                //this.action_value = "supprimer";
            }
        }

        this.DialogCancel();
    }

    InfosMessage(): void {
        this.succes_validation = true;
        //setTimeout(() => {this.succes_validation = false; this.temporary_transaction_name = "";}, 3500);
    }

    initDates(list): void {
        for (var i = 0; i < list.length; i++) {
            var date = list[i].delivery_date;
            var year = Number(date.split('-')[2]);
            var month = Number(date.split('-')[1]) - 1;
            var day = Number(date.split('-')[0]);
            this.date_modif[i] = new Date(year, month, day);
        }
    }

    getDate(date_string: string) {
        var date = date_string;
        var year = Number(date.split('-')[2]);
        var month = Number(date.split('-')[1]) - 1;
        var day = Number(date.split('-')[0]);
        return new Date(year, month, day);
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }


    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }

    selected_tr_Bottom: number = -1;
    SelectedBottom(value: number): void {
        this.selected_tr_Bottom = value;
    }

    ColorBottom(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr_Bottom === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }


    ColorIndexBottom(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr_Bottom === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }

    ngOnInit(): void {
        this.getRefusedPurchaseList();
        this.GetNotValidatePurchaseList();
        this.GetSupplierList();
    }

}



// WEBPACK FOOTER //
// ./src/app/purchasing-list.component.ts